<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<el-card class="box-card col-md-12 mb-1" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>Margin TAC</strong></span>
					</div>
					<div>
						<el-collapse style="margin-top:-21px;">
                            <el-collapse-item>
                                <template slot="title">
                                    <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                                </template>
                                <el-form label-position="top" label-width="100px" class="ml-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Station:">
                                                <el-select v-model="stationid" clearable filterable placeholder="Select Station" size="medium" style="width:100%;">
                                                    <el-option v-for="item3 in spbu.list" :key="item3.BranchId" :label="item3.StationName" :value="item3.StationId">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <el-form-item label="Type">
                                                <el-radio-group v-model="stationtype" size="small" name="type">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Area">
                                                <el-radio-group v-model="area" size="small" name="area">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-6">
                                            <el-form-item label="Owner">
                                                <el-checkbox-group v-model="owners" size="small" name="owner">
                                                    <el-checkbox-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-checkbox-button>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Month Range:">
                                                <div class="block">
                                                    <el-date-picker
                                                    v-model="monthRange"
                                                    type="monthrange"
                                                    align="right"
                                                    size="small" 
                                                    unlink-panels
                                                    range-separator="-"
                                                    start-placeholder="Start Month"
                                                    end-placeholder="End Month"
                                                    format="yyyy-MM"
                                                    value-format="yyyy-MM"
                                                    :picker-options="pickerOptionsMonth">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div class="col-md-6">
                                            <el-form-item label="Tol">
                                                <el-radio-group v-model="lokasi" size="small" name="lokasi">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.lokasi" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col-md-6">
                                            <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                                        </div>
                                    </div>

                                </el-form>
                            </el-collapse-item>
                        </el-collapse>
					</div>

                    <div class="row mt-2">
                        <div class="col-md-3 mb-3">
                            <el-checkbox v-model="showchart">Show Chart</el-checkbox>
                        </div>
                        <div class="col-md-4 mb-3" v-if="showchart">
                            <el-radio-group v-model="charttype">
                                <el-radio label="barchart" size="small">Bar Chart</el-radio>
                                <el-radio label="linechart" size="small">Line Chart</el-radio>
                            </el-radio-group>
                        </div>
                        
                    </div>
                <div class="mb-0" >
                    <BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
                    <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
                </div>
                    
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="h-100 d-flex align-items-center justify-content-center">
                                <ReportResultTable reportname="StationList" :reportdata="reportdata" :reporturl="urlRequestParams" select_url="/plant?station=" idcol="StationId" :loading="loading.table"/>
                                
                            </div>
                        </div>
                    </div>

				</el-card>	
			</div>
		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
//import BaselineComparisonTab from '@/views/pages/BaselineComparisonTab.vue'
import { Rainbow, FuelColor, Penanggalan, AxiosWithJar, Config} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends: Fuel,
	components: { 
		//BaselineComparisonTab,
        ReportResultTable,
		//PetaGmap,
		//Loader,
        LineChart,
		BarChart,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 
			tabList:[
				{label:'Station List', name: 'station_list', index: '0' },
			],

            //
            options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				types:[
					{ value: '', name: 'ALL' },
					{ value: 'SPBU', name: 'SPBU' },
					{ value: 'SPBG', name: 'SPBG' },
					{ value: 'PERTASHOP', name: 'PERTASHOP' },
					{ value: 'SPBU-T', name: 'SPBU-T' },
					{ value: 'SHELTER', name: 'SHELTER' },
                    { value: 'MODULAR', name: 'MODULAR' },
                    { value: 'SATGAS', name: 'SATGAS' },
				],
				owner:[
					//{ value: "", name: "ALL" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
                lokasi:[
					{ value: "", name: "ALL" }, 
					//{ value: "by_location", name: "BY LOCATION" }, 
					{ value: "TOL", name: "TOL" }, 
					{ value: "NON TOL", name: "NON TOL" }, 
				],
			},

            pickerOptionsMonth: {
				shortcuts: [
					{
						text: 'This month',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					}, 
					{
						text: 'This year',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					}, 
					{
						text: 'Last 6 months',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},

            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
			monthRange:[],
            //tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			area: this.$route.query.area ? this.$route.query.area : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : '',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
            owners: ['TAC'],
			stationid: this.$route.query.station ? this.$route.query.station : '',
			showmap:false,
            lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',

            charttype: 'linechart', //barchart //linechart
			chartdata: [],
			showchart: false,
			stacked: true,

            urlRequestParams: '',
			reportdata:[],
			stationListMap:[],
			centeringMap:{},
			zoom:5, 
		}
	},
	watch:
	{
		//stationtype(){ this.resumePilihan() },
		//stationid() { this.resumePilihan() },
        //owner() { this.resumePilihan() },
        //area() { this.resumePilihan() },

       
		stacked() { this.refreshChart(); },
		showtype() { this.refreshChart(); },

		reportdata(){
            this.refreshChart();

			this.stationListMap = this.reportdata["data"]
				.filter(e=> e.Latitude!==null && e.Longitude!==null)
				.map(item=>Object.assign(item,
					{id:item.StationId,name:item.StationName,lat:Number(item.Latitude.replace(',','.')),lng:Number(item.Longitude.replace(',','.'))}))
		},
	}, 
    mounted()
    {
        this.$emit('childrenRoute')
        this.loadStationList()
		this.loadStationTypes()
		this.resumePilihan()
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

        //
        pilihStationDariGmap(stationId,PlantNo) {
            this.$router.push({ path: '/plant', query: { plant: PlantNo ,station: stationId } })
            location.reload()
        },

        refreshChart(){
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""
			
			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a
			
			let b = "OwnershipType"
			let c = (a == "ProductName") ? FuelColor : Rainbow

			this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesArea", false, b, "", 1, 2, c, false, false, false, this.stacked);		
		},

        async resumePilihan() {
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/v1/fuel2/margintac?'

            //if(this.monthRange[0] != 'undefined')
			this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

            //if(this.monthRange[1] != 'undefined')
            this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

			this.urlRequestParams+='&type='+this.stationtype
			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&owner='+this.owner
            this.urlRequestParams+='&owners='+this.owners
            this.urlRequestParams+='&owners='+this.owners
			this.urlRequestParams+='&station='+this.stationid

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        applyFilter() {
			this.resumePilihan()
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>